<vg-header></vg-header>

<section class="content-banner">
    <div
        class="banner-home"
        [style.background-image]="'url(' + getBackgroundImageUrl() + ')'"
    >
        <div class="container info-banner-home gradient-mobile h-100">
            <div class="title-content">
                <h1 class="title-banner">
                    {{ 'vg_landing_home_h1_title' | translate }}
                </h1>
            </div>
            <div class="buttons-banner-home">
                <a
                    class="d-grid btn btn-primary"
                    *ngIf="purchaseEnabled"
                    (click)="onClickGiveGiftCard()"
                    href="javascript:void(0)"
                >
                    {{ 'vg_landing_home_a_start-purchase' | translate }}
                </a>
                <vg-button
                    [underline]="true"
                    [icon]="'next-arrow-light'"
                    [iconPosition]="'right'"
                    [style]="'link-light'"
                    class="link-light"
                    [href]="'dashboard/home' | formatUrl | async"
                    *ngIf="redemptionEnabled"
                    (click)="onClickReedemGiftCard()"
                    ><span class="shadow-text">{{
                        'vg_landing_home_link-redeem' | translate
                    }}</span>
                </vg-button>
            </div>
        </div>
    </div>
</section>

<section class="gift-home-swiper">
    <div class="container">
        <h2 class="swiper-title">
            {{ 'vg_landing_home_gift_swiper-h2-title' | translate }}
        </h2>
        <p class="swiper-text">
            {{ 'vg_landing_home_gift_swiper-text-subtitle' | translate }}
        </p>
        <vg-swiper-landing-home></vg-swiper-landing-home>
    </div>
</section>

<section class="gift-step-home">
    <vg-card-steps
        [stepsInfo]="dataTest"
        title="{{ 'vg_landing_home_gift-step-home-title' | translate }}"
        subTitle="{{ 'vg_landing_home_gift-step-home-subtitle' | translate }}"
        [page]="'home'"
    ></vg-card-steps>
    <div class="buttons-step-home">
        <a
            (click)="goToPurchase()"
            href="javascript:void(0)"
            class="d-grid btn btn-outline-primary"
        >
            {{ 'vg_landing_home_gift-step-home-btn-buy-now' | translate }}
        </a>
    </div>
</section>

<section class="gift-routes-home">
    <div class="container">
        <h2 class="title-routes">
            {{ 'vg_landing_home_gift_routes-home-h2-title' | translate }}
        </h2>
        <div
            (inViewport)="onIntersection($event)"
            (vgEnterTheViewportNotifier)="onIntersection($event)"
            [inViewportOptions]="'{ &quot;threshold&quot;: [1] }'"
            class="row d-none d-lg-flex"
        >
            <div
                [ngClass]="i === 3 ? 'd-lg-none d-xl-block' : ''"
                *ngFor="let route of routes; index as i"
                class="col"
            >
                <vg-swiper-routes [route]="route"></vg-swiper-routes>
            </div>
        </div>
        <div
            (inViewport)="onIntersection($event)"
            (vgEnterTheViewportNotifier)="onIntersection($event)"
            [inViewportOptions]="'{ &quot;threshold&quot;: [1] }'"
            class="row justify-content-center d-flex d-lg-none"
        >
            <div class="swiper-routes">
                <div class="swiper-wrapper">
                    <div
                        *ngFor="
                            let route of routesForSwiper;
                            let i = index;
                            trackBy: identifyRoutes
                        "
                        class="swiper-slide"
                    >
                        <vg-swiper-routes
                            [index]="i"
                            [route]="route"
                        ></vg-swiper-routes>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="gift-redeem-home">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-3 image-redeem">
                <img
                    [src]="'vg/landing/home/banner_icon_redeem_gift.svg' | cdn"
                    alt="redeem"
                />
            </div>
            <div class="col-12 col-lg-9 info-container">
                <div class="row">
                    <div class="col-12 col-lg-8 info">
                        <h4 class="title-redeem">
                            {{
                                'vg_landing_home_gift_title-redeem-h4'
                                    | translate
                            }}
                        </h4>
                        <p>
                            {{ 'vg_landing_home_gift_text-redeem' | translate }}
                        </p>
                    </div>
                    <div class="col-12 col-md-4 button">
                        <a
                            [vgOnClickSendTag]="{
                                event: 'ev_viva_gift_lp',
                                category: 'viva_gift_home_cta',
                                action: 'redeem_viva_gift_code'
                            }"
                            [routerLink]="'dashboard/home' | formatUrl | async"
                            class="d-grid btn btn-outline-light"
                        >
                            {{
                                'vg_landing_home_gift_redeem-btn-text'
                                    | translate
                            }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="gift-business-home">
    <div class="gift-business-home-border" id="gift-bussiness">
        <vg-card-steps
            [stepsInfo]="dataTest_2"
            title="{{ 'vg_landing_home_gift_business-title' | translate }}"
            subTitle="{{
                'vg_landing_home_gift_business-subtitle' | translate
            }}"
            [page]="'home'"
        ></vg-card-steps>
        <div class="buttons-step-home">
            <a
                [vgOnClickSendTag]="{
                    event: 'ev_viva_gift_lp',
                    category: 'viva_gift_home_cta',
                    action: 'viva_gift_enterprise'
                }"
                class="btn d-grid btn-outline-success"
                href="mailto:vivagift@vivaaerobus.com"
            >
                {{ 'vg_landing_home_gift_business-btn-label' | translate }}
            </a>
        </div>
    </div>
</section>

<section class="gift-faq-home">
    <div class="container">
        <div class="faq-home">
            <h4 class="title-faq">
                {{ 'vg_landing_home_gift_title-faq' | translate }}
            </h4>
            <vg-card-faq [faqs]="faqs"></vg-card-faq>
        </div>
    </div>
</section>
<vg-terms-conditions></vg-terms-conditions>
<vg-footer></vg-footer>
